import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getKey } from '../../../shared/utils/tabsUtils';
import { usePermission } from '../../../shared/hooks/usePermission';
import { selectEntitiesByFilters } from '../../../shared/store/views/entityView';
import { deviceTypes } from '../../../shared/enums/deviceTypes';
import { courseToAssignFilters } from '../../../shared/utils/entitiesFiltersUtils';
import Page from '../../../shared/components/ui/page/Page';
import pathRouts from '../../../shared/enums/pathRoute';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import useMyLearningNmm from '../../../shared/components/pages/myLearningPage/useMyLearningNmm';
import AssignStudyGroupPopup from './assignStudyGroup/assignStudyGroupPopup/AssignStudyGroupPopup';
import AssignPopupHeader from './assignStudyGroup/assignPopupHeader/AssignPopupHeader';
import ShowOncePerUser from '../../../shared/components/ui/showOncePerUser/ShowOncePerUser ';
import NmmCard from '../../features/nmmCard/NmmCard';
import FocusCarousel from "../../../shared/components/ui/focusCarousel/FocusCarousel";
import MiniWidget from '../../../shared/components/features/widget/miniWidget/MiniWidget';
import BgtCountersWidget from '../bgtPage/bgtCountersWidget/BgtCountersWidget';
import BgtCarouselWidget from '../../../shared/components/widgetCarousel/bgtCarouselWidget/BgtCarouselWidget';
import CrbCarouselWidget from '../../../shared/components/widgetCarousel/crbCarouselWidget/CrbCarouselWidget';
import HtcCarouselWidget from '../../../shared/components/widgetCarousel/htcCarouselWidget/HtcCarouselWidget';
import Scroll from '../../../shared/components/ui/scroll/Scroll';
import AssignWidget from './assignWidget/AssignWidget'; import HtcWidget from '../../../shared/components/widget/htcWidget/HtcWidget';
import CrbWidget from '../../../shared/components/widget/crbWidget/CrbWidget';
import classes from './MyLearningPage.module.css';


const MyLearningPage = () => {

    const navigate = useNavigate();
    const { texts } = useSelector(state => state.translate);
    const { general } = useSelector(state => state.uiData);
    const { deviceType } = useSelector(state => state.responsive);
    const coursesToAssign = useSelector(state => selectEntitiesByFilters(state, courseToAssignFilters));
    const hasPermission = usePermission();
    const canSeeBgt = hasPermission(getKey("bgt"));
    const canSeeCrb = hasPermission(getKey("crb"));
    const canSeeHtc = hasPermission(getKey("htc"));
    const nmms = useMyLearningNmm();

    return (
        <Page title={texts.myClasses} icon={iconsList.myLearning} onBack={() => navigate(`/${pathRouts.HOME}`)} >
            <div className={classes.MyLearningPage}>
                <AssignPopupHeader Btn={true} />
                <p className={classes.MyClassesTitel}>{texts.myClasses}</p>
                <div className={classes.MyLearningContent}>
                    {nmms.length > 0 &&
                        <div className={classes.CoursesList}>
                            <div className={`${classes.ClassesScrollWrap} ${nmms.length === 1 ? classes.ClassesScrollWrapCompact : ''}`}>
                                <Scroll showDots={nmms.length > 1}>
                                    <div className={classes.DomainsList}>
                                        {nmms.map(studyGroup =>
                                            <NmmCard key={studyGroup.id} studyGroup={studyGroup} />
                                        )}
                                    </div>
                                </Scroll>
                            </div>
                        </div>
                    }
                    <div className={classes.LeftSide}>
                        {hasPermission(getKey("bgt")) && <BgtCountersWidget />}
                        {hasPermission(getKey("crbLearningPage")) && <CrbWidget />}
                        {hasPermission(getKey("htcLearningPage")) && <HtcWidget />}
                        {hasPermission(getKey("google")) &&
                            <MiniWidget text={texts.assmentsClassromToCheck} color={" #FDDB71"} className={classes.ClassroomDesktopWidget} classNameText={classes.textMiniWidget} link={general.classwoomCheckLink} />
                        }
                        <AssignWidget />
                        <FocusCarousel itemSize={100} activeScale={1.6} showDots={false} className={classes.WidgetsCarousel}>
                            {canSeeBgt && <BgtCarouselWidget />}
                            {canSeeCrb && <CrbCarouselWidget />}
                            {canSeeHtc && <HtcCarouselWidget />}
                        </FocusCarousel>
                    </div>
                </div>
                {coursesToAssign?.length > 0 && deviceType !== deviceTypes.mobile &&
                    <ShowOncePerUser id="assign-study-group-popup">
                        <AssignStudyGroupPopup />
                    </ShowOncePerUser>}
            </div >
        </Page>
    );
};

export default MyLearningPage;